import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      // 1. Window scroll reset
      window.scrollTo(0, 0);

      // 2. Main container scroll reset
      const main = document.querySelector("main");
      if (main) {
        main.scrollTop = 0;
      }

      // 3. Any scrollable div reset (extra safety)
      document.querySelectorAll("*").forEach((el) => {
        if (el.scrollHeight > el.clientHeight) {
          el.scrollTop = 0;
        }
      });

    }, 300);

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return null;
};

export default ScrollHandler;